module.exports = __webpack_public_path__ + "img/2V.f7a13321.jpg";